import * as React from 'react';

import { Aside } from '../../components/Aside';
import { BuilderInfoContainer } from '../BuilderInfo';
import { TermsInfoContainer } from '../TermsInfo';
import { TgbBannerContainer } from '../Banners';

export const AsideContainer: React.FC = () => {
  return (
    <Aside
      banner={<TgbBannerContainer type="aside" />}
      builderInfo={<BuilderInfoContainer />}
      termsInfo={<TermsInfoContainer />}
    />
  );
};
